<template>
  <video class="video-widget" :style="style" :src="widget.url" ref="video" :data-show-mute-button="widget.showMuteButton"
         data-html2canvas-ignore="true" muted playsinline autoplay @loadedmetadata="loadedMetaData"/>
</template>

<script>
export default {
  name: 'VideoWidgetView',
  props: {
    widget: {
      type: Object,
    },
  },
  computed: {
    style() {
      return {
        left: this.widget.left === 'unset' ? this.widget.left : `${this.widget.left}px`,
        right: this.widget.right === 'unset' ? this.widget.right : `${this.widget.right}px`,
        top: `${this.widget.top}px`,
        height: `${this.widget.height}px`,
        width: `${this.widget.width}px`,
        transform: `rotate(${this.widget.rotate}deg)`,
        zIndex: this.widget.zIndex,
      };
    },
  },
  methods: {
    loadedMetaData() {
      this.$emit('videoLoaded', this.$refs.video);
    },
  },
};
</script>

<style lang="scss" scoped>
.video-widget {
  position: absolute;
}
</style>
